<template>
    <!--FILTER-->
    <div class="md-layout-item md-size-100">
        <md-card class="pl-1 pr-1">
            <md-card-header class="pb-2">
                <h4 class="title pt-1">Filtrar {{ parameterTypeTitle }}</h4>
            </md-card-header>
            <md-card-content class="pb-2">
                <div class="md-layout">
                    <div
                        class="md-layout-item md-size-20 md-small-size-100"
                        v-if="filterCluster"
                    >
                        <md-field>
                            <label>Cluster</label>
                            <md-input
                                type="text"
                                v-model="filter.cluster"
                            ></md-input>
                        </md-field>
                    </div>
                    <div
                        class="md-layout-item md-small-size-100"
                        :class="{
                            'md-size-15': filterCluster,
                            'md-size-20': !filterCluster
                        }"
                    >
                        <md-field>
                            <label>CD</label>
                            <md-input
                                type="text"
                                v-model="filter.dc"
                            ></md-input>
                        </md-field>
                    </div>
                    <div
                        class="md-layout-item md-small-size-100"
                        :class="{
                            'md-size-15': filterCluster,
                            'md-size-20': !filterCluster
                        }"
                    >
                        <md-field>
                            <label>Estado</label>
                            <md-input
                                type="text"
                                v-model="filter.state"
                            ></md-input>
                        </md-field>
                    </div>
                    <div
                        class="md-layout-item md-small-size-100"
                        :class="{
                            'md-size-15': filterCluster,
                            'md-size-20': !filterCluster
                        }"
                    >
                        <md-field>
                            <label>Cidade</label>
                            <md-input
                                type="text"
                                v-model="filter.city"
                            ></md-input>
                        </md-field>
                    </div>
                    <div
                        class="md-layout-item md-small-size-100"
                        :class="{
                            'md-size-15': filterCluster,
                            'md-size-20': !filterCluster
                        }"
                    >
                        <md-field>
                            <label>Loja</label>
                            <md-input
                                type="text"
                                v-model="filter.branch"
                            ></md-input>
                        </md-field>
                    </div>
                    <div class="md-layout-item md-size-20 md-small-size-100">
                        <md-field>
                            <label>Status</label>
                            <md-select
                                name="status"
                                id="status"
                                v-model="filter.status"
                                placeholder="Todos"
                                multiple
                            >
                                <md-option
                                    v-for="(status, index) in statusList"
                                    v-bind:key="`status-${index}`"
                                    :value="status.slug"
                                >
                                    {{ status.slug }}
                                </md-option>
                            </md-select>
                        </md-field>
                    </div>
                    <div class="md-layout-item md-size-100 text-right mt-1">
                        <md-button
                            class="md-danger md-sm ml-1"
                            @click="clearFilter()"
                        >
                            Limpar
                        </md-button>
                        <md-button
                            class="md-primary md-sm ml-1"
                            @click="applyFilter()"
                        >
                            Pesquisar
                        </md-button>
                    </div>
                </div>
            </md-card-content>
        </md-card>
    </div>
</template>

<script>
const baseFilter = {
    cluster: null,
    dc: null,
    state: null,
    city: null,
    branch: null,
    status: []
}

export default {
    props: {
        baseStore: { type: String, required: true },
        parameterTypeTitle: {
            type: String,
            required: true
        },
        simulation: {
            type: Object,
            default: null
        },
        filterCluster: {
            type: Boolean,
            default: false
        }
    },
    created() {
        this.readParameters = function() {
            this.$store.dispatch.apply(null, [
                this.baseStore + '/read',
                ...arguments
            ])
        }
    },
    data() {
        return {
            filter: { ...baseFilter },

            /**
                Padrao: status ativo e tipo padrao
                Modificado: status ativo e tipo modificado
                Removido: status removido e tipo *
                Removido Manualmente: status removido manualmente e tipo *
             */
            statusList: [
                {
                    slug: 'Padrão',
                    ops: [
                        {
                            type: 'type',
                            value: 'D'
                        },
                        {
                            type: 'status',
                            value: 'A'
                        }
                    ]
                },
                {
                    slug: 'Modificado',
                    ops: [
                        {
                            type: 'type',
                            value: 'M'
                        },
                        {
                            type: 'status',
                            value: 'A'
                        }
                    ]
                },
                {
                    slug: 'Removido',
                    ops: [
                        {
                            type: 'status',
                            value: 'R'
                        }
                    ]
                },
                {
                    slug: 'Removido manualmente',
                    ops: [
                        {
                            type: 'status',
                            value: 'M'
                        }
                    ]
                }
            ],

            // dynamic methods
            readParameters: null
        }
    },
    methods: {
        clearFilter() {
            this.filter = { ...baseFilter }
        },
        applyFilter() {
            let statusSelected = this.statusList.filter(
                status =>
                    this.filter.status.filter(slug => slug == status.slug)
                        .length > 0
            )

            let status = []
            let type = []

            if (statusSelected.length > 0) {
                let opsArray = []

                statusSelected
                    .map(status => status.ops)
                    .forEach(op => op.forEach(item => opsArray.push(item)))

                status = opsArray
                    .filter(op => op.type == 'status')
                    .map(op => op.value)
                status = status.filter(
                    (item, pos) => status.indexOf(item) == pos
                )
                type = opsArray
                    .filter(op => op.type == 'type')
                    .map(op => op.value)
                type = type.filter((item, pos) => type.indexOf(item) == pos)
            }

            if (this.simulation)
                filter['simulation'] = this.simulation.clone
                    ? this.simulation.clone
                    : this.simulation.id

            // triggers an action on the store, which reflects on all components that uses a mapped state
            this.readParameters({
                type:
                    type.length > 0 ? type.reduce((a, b) => a + ',' + b) : null,
                status:
                    status.length > 0
                        ? status.reduce((a, b) => a + ',' + b)
                        : null,

                ...this.filter
            })
        }
    }
}
</script>
